import { Component } from '@angular/core';

@Component({
  selector: 'app-internationalization',
  templateUrl: './internationalization.component.html',
  styleUrls: ['./internationalization.component.scss'],
  standalone: true,
})
export class InternationalizationComponent {}
